var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStarFilled = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#star-filled_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFB241",
    stroke: "#FFB241",
    strokeWidth: 2.004,
    d: "M9.446 3.332a.6.6 0 0 1 1.108 0l1.685 4.053a.6.6 0 0 0 .506.368l4.376.35a.6.6 0 0 1 .342 1.054l-3.333 2.856a.6.6 0 0 0-.194.595l1.019 4.27a.6.6 0 0 1-.896.651l-3.747-2.288a.6.6 0 0 0-.625 0L5.94 17.529a.6.6 0 0 1-.897-.651l1.019-4.27a.6.6 0 0 0-.194-.595L2.536 9.157a.6.6 0 0 1 .342-1.053l4.376-.351a.6.6 0 0 0 .506-.368z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "star-filled_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgStarFilled;